/**
 * ProcessesStep.jsx
 * =================
 * Process builder for setup wizard (Enterprise only)
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import SetupWizard from './SetupWizard';
import ProcessDashboard from '../../pages/ProcessDashboard';

const ProcessesStep = () => {
  const { appName } = useParams();

  return (
    <SetupWizard currentStepKey="processes">
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        border: '1px solid #E5E7EB',
        padding: '32px',
        marginBottom: '20px'
      }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '700',
          color: '#111827',
          marginBottom: '8px'
        }}>
          🔄 Build Process Workflows
        </h2>
        <p style={{
          fontSize: '14px',
          color: '#6B7280',
          marginBottom: '24px'
        }}>
          Create multi-step workflows that guide users through complex processes.
        </p>

        <div style={{
          padding: '24px',
          backgroundColor: '#F9FAFB',
          borderRadius: '8px',
          marginBottom: '24px'
        }}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#111827',
            marginBottom: '12px'
          }}>
            💡 Quick Tips:
          </h3>
          <ul style={{
            fontSize: '14px',
            color: '#6B7280',
            margin: 0,
            paddingLeft: '20px'
          }}>
            <li>Connect multiple pages into a step-by-step flow</li>
            <li>Add validations between steps for conditional routing</li>
            <li>Configure actions to execute at each step</li>
            <li>Skip this step if you don't need complex workflows</li>
          </ul>
        </div>
      </div>

      {/* Embed ProcessDashboard */}
      <ProcessDashboard />
    </SetupWizard>
  );
};

export default ProcessesStep;
























